import Reveal from "./Reveal";

const steps = [
  {
    num: "01",
    title: "Assess",
    desc: "Understand your current technology environment and business priorities.",
  },
  {
    num: "02",
    title: "Plan",
    desc: "Build a practical technology strategy around your goals.",
  },
  {
    num: "03",
    title: "Implement",
    desc: "Deploy and optimize the right technology solutions.",
  },
  {
    num: "04",
    title: "Support",
    desc: "Continuously monitor, maintain, secure, and improve your IT environment.",
  },
];

export default function Process() {
  return (
    <section id="process" className="py-20 md:py-28 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal className="max-w-2xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            Our Process
          </span>
          <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
            A Simpler Approach to IT
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          {/* connecting line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-300 to-transparent" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((s, i) => (
              <Reveal key={s.num} delay={i * 100}>
                <div className="relative text-center lg:text-left">
                  <div className="relative z-10 inline-flex items-center justify-center w-20 h-20 rounded-full bg-foreground-950 text-white font-heading font-bold text-xl mx-auto lg:mx-0">
                    {s.num}
                  </div>
                  <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}